import axios from "axios";

export const HQ_TOKEN_KEY = "hq_token";
const hqApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/hq`, withCredentials: false });
hqApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(HQ_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
hqApi.interceptors.response.use((r) => r, (error) => {
  if (error.response?.status === 401 && localStorage.getItem(HQ_TOKEN_KEY) && !(error.config?.url || "").includes("/auth/login")) {
    localStorage.removeItem(HQ_TOKEN_KEY);
    window.dispatchEvent(new Event("hq:logout"));
  }
  return Promise.reject(error);
});
export const hqErr = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};
export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fileToB64 = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(String(r.result).split(",", 2)[1]); r.onerror = rej; r.readAsDataURL(file); });
export const fileToDataUrl = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(String(r.result)); r.onerror = rej; r.readAsDataURL(file); });
export const POWERED_BY = "Powered by Montana Freight Group software";
export const STATE_LABEL = { draft: "Parsed / Draft", dispatched: "Active / Dispatched", delivered: "Delivered · POD in", remittance_ready: "Remittance Ready", cancelled: "Cancelled" };
export const STATE_CLS = { draft: "bg-neutral-200 text-neutral-800", dispatched: "bg-sky-100 text-sky-900", delivered: "bg-amber-100 text-amber-900", remittance_ready: "bg-emerald-100 text-emerald-900", cancelled: "bg-red-100 text-red-800" };
export default hqApi;
